import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Tooltip
} from "@mui/material";
import { getMemberInductionDataApi } from "src/api/commonapi";
import { Routes } from "../constant/api_url";
import { notification } from "src/utils/messages";
import CustomLoader from "src/commonComponents/CustomLoader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MemberProfileModal from "./MemberProfile";
import CloseIcon from "@mui/icons-material/Close";

const THEME_COLOR = "#1c4766";

export default function InductedMemberProfileModal({
  setMemberProfileId,
  memberProfileId,
  inductedMemberProfileModal,
  toggleInductedMemberProfileModal
}) {
  const [inductedMemberData, setInductedMemberData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [historyTracker, setHistoryTracker] = useState([]);
  const [memberProfileModal, setMemberProfileModal] = useState(false);
  const [membersProfileIds, setMembersProfileIds] = useState(null);

  const toggleMemberProfileModal = () => setMemberProfileModal(!memberProfileModal);

  useEffect(() => {
    GetMemberProfile(memberProfileId);
  }, [memberProfileId]);

  const GetMemberProfile = async (id) => {
    setIsLoading(true);

    const resp = await getMemberInductionDataApi(id);
    if (resp.status == 1) {
      setInductedMemberData(resp?.data);
    } else {
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    GetMemberProfile(memberProfileId);
    if (historyTracker?.length == 0) setHistoryTracker((prev) => [...prev, memberProfileId]);
  }, [memberProfileId]);

  return (
    <Fragment>
      <Dialog
        open={inductedMemberProfileModal}
        onClose={toggleInductedMemberProfileModal}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: "16px",
            maxHeight: "90vh",
            overflow: "hidden",
            border: "1px solid #e0e0e0",
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)"
          }
        }}
      >
        {!isLoading ? (
          <>
            <DialogContent
              sx={{
                p: 2,
                backgroundColor: "#f4f7fb",
                overflowY: "auto",
                maxHeight: "calc(90vh)"
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      backgroundColor: THEME_COLOR,
                      color: "#fff",
                      px: 2,
                      py: 3,
                      margin: "-16px -16px 16px -16px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "sticky",
                      top: -18,
                      zIndex: 10
                    }}
                  >
                    <Typography variant="h6" fontWeight={600}>
                      Inducted Member ({inductedMemberData?.length || 0})
                    </Typography>
                    {historyTracker?.length > 1 && (
                      <Tooltip title="Back">
                        <IconButton
                          onClick={() => {
                            GetMemberProfile(historyTracker[historyTracker?.length - 2]);
                            setHistoryTracker((prev) => prev.slice(0, -1));
                          }}
                          sx={{
                            color: "#fff"
                          }}
                        >
                          <ArrowBackIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Close">
                      <IconButton
                        onClick={toggleInductedMemberProfileModal}
                        sx={{
                          position: "absolute",
                          right: 15,
                          top: 15,
                          color: "#fff",
                          backgroundColor: "#d32f2f",
                          boxShadow: "0 6px 18px rgba(211, 47, 47, 0.3)",
                          "&:hover": {
                            backgroundColor: "#b71c1c",
                            boxShadow: "0 8px 22px rgba(211, 47, 47, 0.4)"
                          }
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      {inductedMemberData?.length > 0 ? (
                        <Grid container spacing={2}>
                          {inductedMemberData?.map((item, i) => (
                            <Grid item xs={12} sm={6} key={i}>
                              <Box
                                sx={{
                                  position: "relative",
                                  p: 2,
                                  pl: 2.5,
                                  borderRadius: 3,
                                  backgroundColor: "#ffffff",
                                  border: "1px solid #e5e7eb",
                                  display: "flex",
                                  gap: 1.5,
                                  alignItems: "center",
                                  transition: "all 0.25s ease",
                                  overflow: "hidden",
                                  "&:hover": {
                                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                                    transform: "translateY(-4px)"
                                  }
                                }}
                              >
                                <Box
                                  sx={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    width: 5,
                                    background: "linear-gradient(180deg, #2563eb, #7c3aed)"
                                  }}
                                />

                                <Box
                                  sx={{
                                    position: "relative",
                                    flexShrink: 0,
                                    ml: 1,
                                    display: "flex",
                                    alignItems: "center"
                                  }}
                                >
                                  <Avatar
                                    src={`${Routes.API_HOSTNAME}images/member/${item.photo}`}
                                    alt={item.m_name}
                                    onClick={() => {
                                      toggleMemberProfileModal();
                                      setMembersProfileIds(item.m_id);
                                      // setHistoryTracker((prev) => [...prev, item.m_id]);
                                    }}
                                    sx={{
                                      width: 55,
                                      height: 55,
                                      cursor: "pointer"
                                    }}
                                  />

                                  {item.m_verify_status === 2 && (
                                    <Box
                                      component="img"
                                      src="/static/icons/verified_blue.png"
                                      alt="Verified"
                                      sx={{
                                        width: 16,
                                        height: 16,
                                        position: "absolute",
                                        top: -1,
                                        right: 3
                                      }}
                                    />
                                  )}
                                </Box>

                                <Box sx={{ flex: 1 }}>
                                  <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <Typography variant="subtitle2" fontWeight={600}>
                                      {item?.m_name}
                                    </Typography>

                                    <Typography variant="caption" color="text.secondary">
                                      {item?.joining_date}
                                    </Typography>
                                  </Stack>
                                  <Typography variant="subtitle2">{item?.city_name}</Typography>
                                  <Typography variant="subtitle2">
                                    {item?.business_category}
                                  </Typography>
                                  <Typography variant="subtitle2">{item?.business_name}</Typography>
                                  <Typography variant="subtitle2">{item?.mobile_no}</Typography>
                                </Box>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      ) : (
                        <Box sx={{ width: "100%", textAlign: "center", py: 1 }}>
                          <Typography color="text.secondary">No Inducted Members Yet.</Typography>
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
          </>
        ) : (
          <Box
            sx={{
              height: "90vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CustomLoader />
          </Box>
        )}
      </Dialog>
      {memberProfileModal && (
        <MemberProfileModal
          memberProfileModal={memberProfileModal}
          memberProfileId={membersProfileIds}
          setMemberProfileId={setMembersProfileIds}
          toggleMemberProfileModal={toggleMemberProfileModal}
        />
      )}
    </Fragment>
  );
}
